// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__O3bV9","searchIconWrapper":"Search_searchIconWrapper__O-a2H"};